var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSmallCheckIcon = function SvgSmallCheckIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5.-Health-Screening",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.15.14-Setup-/-Location-/-Create-new-location-/-Step-2---completed-1-day",
    transform: "translate(-409.000000, -220.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Left",
    transform: "translate(276.000000, 210.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(133.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "checkmark-circle",
    mask: "url(#mask-2)",
    fill: "#AD5E99",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.000000, 4.000000)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.125,0 C3.64492188,0 0,3.64492188 0,8.125 C0,12.6050781 3.64492188,16.25 8.125,16.25 C12.6050781,16.25 16.25,12.6050781 16.25,8.125 C16.25,3.64492188 12.6050781,0 8.125,0 Z M12.3535156,5.40195313 L7.10351563,11.6519531 C6.98699125,11.7907436 6.81596292,11.8721246 6.63476563,11.875 L6.62421875,11.875 C6.44705569,11.875 6.27824342,11.7996873 6.15976563,11.6679688 L3.90976563,9.16796875 C3.75421475,9.00298564 3.70022215,8.76669509 3.7686794,8.55052593 C3.83713664,8.33435677 4.01730437,8.17222097 4.23946956,8.12685438 C4.46163475,8.08148779 4.69094481,8.16000738 4.83867188,8.33203125 L6.6078125,10.2976562 L11.3964844,4.59804688 C11.6199915,4.33963884 12.00958,4.30859459 12.2711891,4.52834627 C12.5327983,4.74809795 12.569466,5.13719744 12.3535156,5.40195313 Z"
  })))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSmallCheckIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/small-check-icon.324a93e2.svg";
export { ForwardRef as ReactComponent };